// ページ内アンカーリンクのスクロールエフェクト
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定)
jQuery(function ($) {
  // var headerHeight = 0; // ヘッダー追従でない場合
  var headerHeight = $("header").innerHeight(); // ヘッダー追従の場合
  $('a[href^="#"]').click(function () {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    if (target.length > 0) {
      var position = target.offset().top - headerHeight;
      $("html, body").animate({ scrollTop: position }, 550, "swing");
      return false;
    }
  });
});

// ブログサムネイル 中心でトリミング
jQuery(function ($) {
  if ($(".obj_image").length > 0) {
    objectFitImages(".obj_image");
  }
});

// レスポンシブ画像切り替え imgにclass「js-image-switch」
jQuery(function ($) {
  if ($(".js-image-switch").length > 0) {
    var $elem = $(".js-image-switch");
    var sp = "_sp.";
    var pc = "_pc.";
    // 画像を切り替えるウィンドウサイズ
    var replaceWidth = 768;

    function imageSwitch() {
      var windowWidth = parseInt($(window).width());
      $elem.each(function () {
        var $this = $(this);
        if (windowWidth >= replaceWidth) {
          $this.attr("src", $this.attr("src").replace(sp, pc));
        } else {
          $this.attr("src", $this.attr("src").replace(pc, sp));
        }
      });
    }
    imageSwitch();

    var resizeTimer;
    $(window).on("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        imageSwitch();
      }, 200);
    });
  }
});

// アコーディオンの起動
jQuery(function ($) {
  if ($("dl.accordion dt").length > 0) {
    $("dl.accordion dt").click(function () {
      $(this).next("dd").slideToggle();
      $(this).toggleClass("open");
    });
  }
});

// ドロワーメニュー
jQuery(function ($) {
  if ($("#toggle").length > 0) {
    $("#toggle").click(function () {
      $(this).toggleClass("toggle_active");
      $("#drawer_layer").fadeToggle();
      $("body").toggleClass("drawer_open");

      if ($(this).hasClass("toggle_active")) {
        $("nav").addClass("is_open");
        $("nav").removeClass("is_close");
      } else {
        $("nav").removeClass("is_open");
        $("nav").addClass("is_close");
      }
    });

    $("#drawer_layer").click(function () {
      $(this).fadeOut();
      $("#toggle").removeClass("toggle_active");
      $("body").removeClass("drawer_open");
      $("nav").removeClass("is_open");
      $("nav").addClass("is_close");
    });

    // エリア内リンク用
    $("nav a").on("click", function () {
      // if (window.innerWidth <= 768) {
      if ($("#toggle:visible").length > 0) {
        $("#toggle").click();
      }
    });
  }
});

jQuery(function ($) {
  $(".g-c-faq").slice(0, 3).show();
  $("#load-more").on("click", function (e) {
    e.preventDefault();
    $(".g-c-faq:hidden").slice(0, 3).slideDown();
    if ($(".g-c-faq").length == 6) {
      $("#load-more").fadeOut();
    }
  });
});

jQuery(function ($) {
  $(window).scroll(function () {
    var scrollPosition = $(window).scrollTop();
    var windowHeight = $(window).height() / 2;
    $(".sharing-box").each(function () {
      var position = $(this).offset().top;

      if (position < scrollPosition + windowHeight) {
        $(".flow-ttl").removeClass("active");
        $(".flow-ttl1").addClass("active");
      }
    });

    $(".execution-box").each(function () {
      var position = $(this).offset().top;

      if (position < scrollPosition + windowHeight) {
        $(".flow-ttl").removeClass("active");
        $(".flow-ttl2").addClass("active");
      }
    });

    $(".business-box").each(function () {
      var position = $(this).offset().top;

      if (position < scrollPosition + windowHeight) {
        $(".flow-ttl").removeClass("active");
        $(".flow-ttl3").addClass("active");
      }
    });
  });
});

jQuery(function ($) {
  $(document).ready(function () {
    // if ($(window).width() > 768) {
    $(".popup01").addClass("animate__animated animate__bounceIn");
    // }
  });

  $(window).scroll(function () {
    var scrollPosition = $(window).scrollTop();

    $(".g-p-sec").each(function () {
      var divPosition = $(this).offset().top;
      var divMextPosition = 99999999;
      if ($(this).next(".g-p-sec").offset() !== undefined) {
        divMextPosition = $(this).next(".g-p-sec").offset().top;
      }

      if (divPosition - scrollPosition < $(window).height() - 200 && divMextPosition - scrollPosition >= $(window).height() - 200) {
        var popupId = $(this).data("popup");
        $(".popup").not(popupId).hide();

        if ($(popupId).css("display") == "none") {
          $(popupId).show();
        }
      }
    });
  });
});

//一文字ずつspanで囲む
var element = $(".ani_eachText");
var elementBottom = $(".ani_eachText_bottom");
element.each(function () {
  var text = $(this).text();
  var textbox = "";
  text.split("").forEach(function (t, i) {
    if (t !== " ") {
      if (i < 10) {
        textbox += '<span style="animation-delay:.' + i + 's;">' + t + "</span>";
      } else {
        var n = i / 10;
        textbox += '<span style="animation-delay:' + n + 's;">' + t + "</span>";
      }
    } else {
      textbox += t;
    }
  });
  $(this).html(textbox);
});
elementBottom.each(function () {
  var text = $(this).text();
  var textbox = "";
  text.split("").forEach(function (t, i) {
    if (t !== " ") {
      if (i < 10) {
        textbox += '<span style="animation-delay:1.' + i + 's;">' + t + "</span>";
      } else {
        var n = i / 10;
        textbox += '<span style="animation-delay:' + n + 's;">' + t + "</span>";
      }
    } else {
      textbox += t;
    }
  });
  $(this).html(textbox);
});

function scrollAnim() {
  $(".scroll-anim").each(function () {
    var elemPos = $(this).offset().top - 50; //要素より、50px上の
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll >= elemPos - windowHeight) {
      $(this).addClass("done");
    }
  });
}

$(window).scroll(function () {
  scrollAnim();
});

//fv animation
$(function () {
  var windowHeight = $(window).height();

  $(window).on("scroll", function () {
    var scroll = $(window).scrollTop();

    var arr = ["fv-main01", "img2", "img3"];

    const stickyHeight = 250;
    const bubbleActionHeight = 400;
    const scrollAnimStop = 540;

    if (scroll > scrollAnimStop) {
      $(".fv-main02-ani").addClass("ani_popin_on");
    } else if (scroll > bubbleActionHeight) {
      $(".jsFvBubble, .jsFvMain02").css("transform", "translateY(" + ((scroll - stickyHeight) / 4 - (scroll - bubbleActionHeight) / 0.4) + "px");
      $(".jsFvMain01, .jsFvitems").css("transform", "translateY(" + (scroll - stickyHeight) / -0.65 + "px");
    } else if (scroll > stickyHeight) {
      $(".jsFvBlock").removeClass("sticky");
      $(".jsFvMain01, .jsFvitems").css("transform", "translateY(" + (scroll - stickyHeight) / -0.65 + "px");
      $(".jsFvBubble, .jsFvMain02").css("transform", "translateY(" + (scroll - stickyHeight) / 4 + "px");
    } else {
      $(".jsFvBlock").addClass("sticky");
      $(".jsFvMain01, .jsFvitems, .jsFvBubble").css("transform", "none");
    }
  });
});
